import front from './view';

export default [
  {
    path: 'search/:cat',
    redirect: 'search/:cat/list',
  },
  {
    path: 'search/:cat/list',
    component: front('/search/searchList'),
  },
  {
    path: 'search/:cat/:certNo',
    component: front('/search/searchDetail'),
  },
];




// WEBPACK FOOTER //
// ./src/router/front/search.js